import { io } from 'socket.io-client';

const isLocal = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
const socketURL = isLocal ? 'http://localhost:5555' : process.env.REACT_APP_SOCKET_URL;

const socket = io(socketURL, {
  transports: ['websocket', 'polling'],
  autoConnect: false,
  reconnection: true,
  reconnectionAttempts: 5,
  withCredentials: true,
  auth: {
    token: localStorage.getItem('token') || ''
  }
});

export const connectSocket = () => {
  const token = localStorage.getItem('token') || '';
  socket.auth = { token };

  if (!socket.connected) {
    socket.connect();
  }
};

export const disconnectSocket = () => {
  if (socket.connected) {
    socket.disconnect();
  }
};

socket.on('connect', () => {
  if (process.env.NODE_ENV !== 'production') {
    // console.log('✅ [Socket] Connecté avec ID :', socket.id);
  }
});

socket.on('disconnect', (reason) => {
  console.warn('⚠️ [Socket] Déconnecté du serveur :', reason);
});

socket.on('connect_error', (err) => {
  console.error('❌ [Socket] Erreur de connexion :', err.message);
});

export default socket;